export default {"src":"/_next/static/media/play-icon.c3a025c1.svg","height":57,"width":50};